import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout/layout.vue'
import Login from './views/login/login.vue'

Vue.use(Router)
export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'layout',
      component: Layout,
      redirect: 'home',
      beforeEnter: (to, from, next) => {
        // 全局路由防卫
        if (sessionStorage.getItem('MENU') || to.path == '/login') {
          next()
        } else {
          next('/login')
        }
      },
      children: [
        {
          path: 'home',
          name: '首页',
          component: resolve =>
            require(['./views/pages/home/home.vue'], resolve)
        },
        {
          path: 'v1/dpt',
          name: '部门列表',
          component: resolve =>
            require(['./views/pages/dpt-list/index.vue'], resolve)
        },
        {
          path: 'v1/sub',
          name: '订阅列表',
          component: resolve =>
            require(['./views/pages/sub-list/index.vue'], resolve)
        },
        {
          path: '/v1/acct',
          name: '账号管理',
          component: resolve =>
            require(['./views/pages/acct-list/index.vue'], resolve)
        },
        {
          path: '/v1/sim',
          name: 'sim卡列表',
          component: resolve =>
            require(['./views/pages/sim-list/index.vue'], resolve)
        },
        {
          path: '/v1/sms',
          name: 'sms管理',
          component: resolve =>
            require(['./views/pages/sms-list/index.vue'], resolve)
        },
        {
          path: 'v1/user_log',
          name: '用户日志',
          component: resolve =>
            require(['./views/pages/user-log/index.vue'], resolve)
        },
        {
          path: '/v1/cg',
          name: '分组列表',
          component: resolve =>
            require(['./views/pages/cg-list/index.vue'], resolve)
        },
        {
          path: 'v1/sub_log',
          name: '订阅日志',
          component: resolve =>
            require(['./views/pages/sub-log/index.vue'], resolve)
        },
        {
          path: 'v1/rule',
          name: '规则列表',
          component: resolve =>
            require(['./views/pages/rule-list/index.vue'], resolve)
        },
        {
          path: 'v1/define',
          name: '定义列表',
          component: resolve =>
            require(['./views/pages/define-list/index.vue'], resolve)
        }
      ]
    }
  ]
})
